// Catalogs tab of the creator asset library page: activates the tab named in
// the URL hash, keeps the hash in sync, and guards the Your-catalogs form's
// unsaved picks. (Catalogs themselves are curated centrally by admins —
// nothing to author here anymore.)

function filingSelects() {
  return Array.prototype.slice.call(
    document.querySelectorAll(".js-filing-form .js-catalog-tree-value")
  )
}

function filingDirty() {
  return filingSelects().some(function (select) {
    return (
      select.dataset.originalValue !== undefined &&
      select.value !== select.dataset.originalValue
    )
  })
}

// Submitting IS saving — don't let the leave-guards fire on the form's own
// navigation.
var filingSubmitting = false
$(document).on("submit", ".js-filing-form", function () {
  filingSubmitting = true
})

// A picker edited high in a long table is easy to lose track of before the
// submit button scrolls into view: mark changed rows until saved or
// reverted. The picker's own row is a two-<tr> pair (summary + tree, see
// _catalogs_tab.html.erb) — flag both so the highlight reads as one row.
$(document).on("change", ".js-filing-form .js-catalog-tree-value", function () {
  if (this.dataset.originalValue === undefined) return
  var dirty = this.value !== this.dataset.originalValue
  var $summaryRow = $(this).closest("tr")
  $summaryRow.toggleClass("table-warning", dirty)
  $summaryRow.next("tr.js-catalog-tree-row").toggleClass("table-warning", dirty)
})

document.addEventListener("turbolinks:before-visit", function (event) {
  if (filingSubmitting || !filingDirty()) return
  if (!confirm("You have unsaved filing changes. Leave without saving them?")) {
    event.preventDefault()
  }
})

window.addEventListener("beforeunload", function (event) {
  if (filingSubmitting || !filingDirty()) return
  event.preventDefault()
  event.returnValue = ""
})

$(document).on("turbolinks:load", function () {
  var page = document.getElementById("js-asset-library-page")
  if (!page) return

  filingSubmitting = false
  filingSelects().forEach(function (select) {
    select.dataset.originalValue = select.value
  })

  // Land on the tab named by the URL hash (e.g. redirects to #catalogs).
  var hash = window.location.hash
  if (hash) {
    var trigger = page.querySelector(
      '[data-bs-toggle="tab"][data-bs-target="' + hash + '"]'
    )
    if (trigger) trigger.click()
  }

  // Keep the hash in sync with the active tab — a stale hash would otherwise
  // yank the user to that tab on the next full page load (redirects after
  // actions, refreshes), since the activation above runs on every load.
  $(page).on("shown.bs.tab", '[data-bs-toggle="tab"]', function () {
    history.replaceState(null, "", this.dataset.bsTarget)
  })
})

// Cross-tab links inside tab panes ("see the Catalogs tab", "file them from
// the Assets tab") — Bootstrap only activates tabs from their nav triggers,
// so route the click to the trigger matching the link's #hash.
$(document).on("click", ".js-goto-tab", function (event) {
  event.preventDefault()
  var trigger = document.querySelector(
    '[data-bs-toggle="tab"][data-bs-target="' + this.getAttribute("href") + '"]'
  )
  if (trigger) trigger.click()
})
